import React from 'react';
import {
    AppShell,
    Footer,
    Grid,
    SimpleGrid,
    createStyles,
    Group,
    ActionIcon,
    Badge,
    Avatar,
} from '@mantine/core';
import {
    IconBell,
    IconHome,
    IconMapPin,
    IconUser,
    IconSettings,
} from '@tabler/icons';


const useStyles = createStyles((theme) => ({
    footer: {
        //display: 'flex',
        margin: 0,
        justifyContent: 'center',
        
        backgroundColor: 'white',
        //marginTop: 120,
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
        bottom: 0,
        height: '35px',
        width: '99%',
        position: 'relative',
        
    },
    home_btn: {
        marginTop: '3%',
        margin: '0 auto'
        
    },
    footerAreaWBorder: {
        width: '25%',
        height: '100%',
        //borderRight: '1px ridge grey',
    },
    footerArea: {
        width: '25%',
        height: '100%',
    },
    menuItem: {
        width: '99%',
        height: '99%',
        justifyContent: 'center',
        pointerEvents: null,
    },

    links: {
        [theme.fn.smallerThan('xs')]: {
            marginTop: theme.spacing.md,
        },
    },
}));

export function FooterSimple() {
    const { classes } = useStyles();
    const { footerClassesA } = 'footer footerAreaA';
    //temporary to ensure we understand clicks then... set up the dispatch events
    function handleMenuClick(e) {
        console.log("menu area clicked");
        console.log(e.target.id);
        console.log(window.screen.width);
        console.log(window.screen.height);
        console.log("after width X height");
    }
    //pass state control the function to go home
    
    return (
        <footer className={classes.footer}>
            <ActionIcon color="dark" size="xl" className={classes.home_btn}>
                <IconHome size="8em" color="black"/>
            </ActionIcon>
        </footer>
  );
}
